
import React, { useState } from "react";

/** validation de formulaire */
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import usePostAxiosData from "hooks/usePostAxiosData";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { AppBar, Dialog, DialogContent, Divider, List, Paper, Toolbar, Typography } from "@mui/material";
import MButton from "components/Mbutton";
import { CloseModalButton } from "components/Utils";
import { useAuthUser } from "react-auth-kit";
import { BsSignMergeLeft } from "react-icons/bs";
import InputField from "components/fields/InputField";


const MergeEmployee = ({ isOpen, onClose, selectedEployees, handleEndSuccess }) => {
  // console.log("🚀 ~ MergeEmployee ~ selectedEployees:", selectedEployees)
  const auth = useAuthUser();
  const selectedMainEmployee = selectedEployees[0]


  /** post create user */
  const [loading, postAxiosData, errorMassage, successMessage, result] =
    usePostAxiosData((selectedMainEmployee?.id && selectedEployees?.length > 0) ? `employers/${selectedMainEmployee?.id}/merge-with` : null, "POST", false);
  const handleMerge = async (data) => {
    if (selectedEployees?.length < 2) {
      toast.error("Veuillez selectionner au moins deux employes pour la fusion.")
    } else {
      postAxiosData({
        ids: selectedEployees?.filter((e) => e.id != selectedMainEmployee.id)?.map((e) => e.id),
        creatorId: auth()?.user?.id,
        reason: data.reason || "Fusion des employes",
      });
    }
  };



  /** gestion des erreurs et succès */
  useEffect(() => {
    // handleEndSuccess && handleEndSuccess(result?.data);
    // onClose()
    errorMassage?.message && toast.error(
      `${errorMassage?.message != null ? errorMassage?.message : "Erreur lors de la fusion."} `,
      {
        duration: 4000,
        // icon: "👏",
        className: "bg-danger text-white",
      }
    );

  }, [errorMassage]);
  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {

      toast.success(
        `${successMessage?.message != null
          ? successMessage?.message
          : "Fusion effectuee avec success."
        } `,
        {
          duration: 4000,
          // icon: "👏",
          className: "bg-success text-white",
        }
      );
      toast((t) => (
        <div className="flex flex-col gap-2 justify-center items-center">
          <Typography variant="h5" color="text.primary">
            {`La fusion a été effectuée avec succès. `}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Rassurez-vous maintenant que vous avez bien fusionné les employés (et contracts) et que vous avez mis à jour les informations de l'employé principal.
          </Typography>
          <MButton
            variant={"danger"}
            onClick={(e) => {
              e?.stopPropagation()
              e?.preventDefault()
              toast.dismiss(t.id)
              // window.location.reload();
            }}> Compris !</MButton>
        </div>
      ), { duration: 50000 });
      handleEndSuccess && handleEndSuccess(result?.data);
      handleClose()
    }
  }, [successMessage]);

  const handleClose = () => {
    onClose();
    reset();
  };

  const CardDisplatTextItem = ({ label, value }) => {
    return (
      <div className="flex flex-col gap-2">
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body1" color="text.primary">
          {value}
        </Typography>
      </div>
    )
  }

  const Card = ({ item }) => {
    return (
      <div className="grid grid-cols-4 p-4 gap-2">
        <CardDisplatTextItem label={"Nom"} value={item?.Noms} />
        <CardDisplatTextItem label={"Poste"} value={item?.Poste} />
        <CardDisplatTextItem label={"Salaire"} value={item?.Salaire} />
        <CardDisplatTextItem label={"Status"} value={item?.Status} />
      </div>
    );
  }

  const schema = yup.object().shape({
    reason: yup.string().required("This is a required field"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data) => {
    handleMerge(data)
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      // sx={{minHeight : 400}}
      // TransitionComponent={Transition}
      >
        <AppBar
          sx={{ position: 'relative' }}>
          <Toolbar
            className="bg-gray-50"
          >
            <Typography sx={{ ml: 2, flex: 1 }} color={'green'} fontWeight={'bold'} variant="h6" component="div" >
              {`Fusionner les employees dans  
                `

              }
              {selectedMainEmployee?.datas?.Noms}
            </Typography>
            <CloseModalButton iconColor={'red'} handleClose={onClose} />

          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Paper className="mt-3" aria-label="secondary mailbox folders">
              <div className="mb-5 bg-green-100">
                <Card item={selectedEployees?.find((d) => d?.id == selectedMainEmployee?.id)?.datas} />
              </div>
              <div className="flex justify-center">

                <BsSignMergeLeft size={40} color="orange" />
              </div>
              <Divider />

              <List title="">
                {
                  selectedEployees ? selectedEployees?.filter((d) => d?.id != selectedMainEmployee?.id).map((same) => {
                    return (
                      <>
                        <Card key={same?.id} item={same?.datas} />
                        <Divider variant="inset" component="li" />
                      </>
                    )
                  })
                    :
                    <p>Aucun</p>
                }
              </List>
            </Paper>
            <Divider />
            <div className="my-4">
              <InputField
                variant="auth"
                extra="mb-3"
                label="Pourquoi effectuez vous cette fusion ?"
                required={true}
                // placeholder="pourquoi effectuez vous cette fusion ?"
                id="reason"
                name="reason"
                register={register}
                error={errors.reason?.message !== "" ? errors.reason?.message : ""}
                type="text"
                multiline
              />
            </div>
            <div className="flex justify-between p-4">
              <div>
                <MButton
                  type="button"
                  variant={"danger"}
                  onClick={(e) => {
                    e?.stopPropagation()
                    e?.preventDefault()
                    onClose();
                    // window.location.reload();
                  }}>Fermer</MButton>
              </div>
              {selectedEployees?.length > 0 && <MButton
                // onClick={handleMerge}
                disabled={loading}
                isLoading={loading}

                variant={"primary"}
                type="submit"
                colorScheme="green">
                Fusionner
              </MButton>}
            </div>
          </form>

        </DialogContent>
      </Dialog>
    </>
  );
};

export default MergeEmployee;
